import * as React from "react";
import OpQuotesHeadingMfDsk, { IOpQuotesHeadingMfDskProps } from "../partials/opQuotesHeadingMfDsk";
import OpQuotesHoldings from "../partials/opQuotesHoldings";
import OpMarketDepthList from "../partials/opMarketDepthList";
import "../../../../../assets/scss/components/toc/orderPlacement/opQuotes/opQuotesDsk.scss";
import moment from "moment";
import { toINR } from "../../../../service/numberFormat";

export interface IOpQuotesMfDskProps {
	quoteData: any;
	quoteDataExtra: any;
	holdingData?: any;
}

const OpQuotesMfDsk: React.FC<IOpQuotesMfDskProps> = props => {
	const quotesHeadingProps: IOpQuotesHeadingMfDskProps = {
		SchemeName: props.quoteData.SchemeName,
		nav: props.quoteData.nav,
		changeinnav: props.quoteData.changeinnav,
		changeinnavper: props.quoteData.changeinnavper,
		navdateformat: props.quoteData.navdateformat
	};

	return (
		<div className="quotes_cont">
			<OpQuotesHeadingMfDsk {...quotesHeadingProps} />

			<button className="change_btn" onClick={console.log}>
				Change
			</button>

			{props.holdingData && (
				<OpQuotesHoldings
					data={[
						{ label: "Current Value", value: `₹ ${toINR(+props.holdingData.units * +props.holdingData.nav)}` },
						{ label: "Units", value: toINR(props.holdingData.units) }
						// { label: "Unrealised G/L", value: "₹ 1,23,532.56 (12.34%)" }
					]}
					hldgOrPos="holding"
				/>
			)}

			<div className="mg-t15 mg-b2">
				<OpMarketDepthList
					data={[
						{ label: "AUM (in Crs.)", value: toINR(props.quoteDataExtra.AUM) },
						{ label: "MorningStar Rating", value: props.quoteDataExtra.Rating || "0" },
						{ label: "Benchmark Index", value: props.quoteDataExtra.Benchmark || "--" },
						{ label: "Category", value: props.quoteDataExtra.Category || "--" },
						{
							label: "Inception Date",
							value: props.quoteDataExtra.InceptionDate ? moment(props.quoteDataExtra.InceptionDate).format("DD MMM YYYY") : "--"
						},
						{ label: "Risk Category", value: props.quoteDataExtra.RiskCategory || "--" },
						{ label: "3Yr Returns (%)", value: props.quoteDataExtra.Year3 ? `${props.quoteDataExtra.Year3}%` : "--" }
					]}
				/>
			</div>
		</div>
	);
};

export default OpQuotesMfDsk;
